app.views.complaints = app.views.base.extend({
  childEvents: {
    'change [data-attachments]': 'onAddingAttachments'
  },
  attr: {
    success: 'data-form-success',
    spinner: 'data-form-spinner',
    validationSummary: 'data-valmsg-summary'
  },
  init: function init() {},
  onSuccessfulSubmission: function onSuccessfulSubmission(id, isAccessedFromMobileApp) {
    var form = $(id);
    var errors = form.find('.validation-summary-errors');
    if (errors.length < 1) {
      if (isAccessedFromMobileApp) {
        window.location = "/app/submit-success";
      } else {
        $('[' + this.attr.success + ']').show();
      }
      form.trigger('reset');
      form.find('input[type=text], textarea').val('');
      dataLayer.push({
        event: 'formSubmission',
        formType: 'Complaints'
      });
    }
    app.initElementListeners('#ComplaintsFormContainer');
  },
  onFailedSubmission: function onFailedSubmission() {
    $('[' + this.attr.spinner + ']').hide();
    var vs = $('[' + this.attr.validationSummary + ']');
    $(vs).children('ul').empty();
    vs.children('ul').append($('<li></li>').text("There has been an error submitting the complaints form. Please try again later."));
    window.scrollTo(0, 0);
  },
  onAddingAttachments: function onAddingAttachments(e) {
    var MAX_FILE_COUNT = 4;
    var input = $(e.currentTarget);
    var form = input.parents('form');
    var files = input[0].files;
    if (files.length > MAX_FILE_COUNT) {
      var vs = $('[' + this.attr.validationSummary + ']');
      vs.children('ul').append($('<li></li>').html('A maximum of ' + MAX_FILE_COUNT + ' files can be uploaded.'));
      form.trigger('reset');
    }
  }
});